module.exports = __webpack_public_path__ + "img/n-logo.3d391b7e.png";